// extracted by mini-css-extract-plugin
export default {"buy":"politicas_buy__77NjS","title":"politicas_title__N1mp0","icon":"politicas_icon__eRQkR","contenido":"politicas_contenido__geQ70"};